import { render, staticRenderFns } from "./PassportScanUploadManualSection.vue?vue&type=template&id=936b2c04&"
import script from "./PassportScanUploadManualSection.vue?vue&type=script&lang=js&"
export * from "./PassportScanUploadManualSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports